// extracted by mini-css-extract-plugin
export default {"Questionimage":"QuestionTypes_Questionimage__nBze2"};